import React from 'react';
import './ChLang.css';

export default function ChLang(props) {
  return <button className="chlang" onClick={()=>props.f(props.lang)}>
    {props.children}
  </button>;
}
